import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    hireBanner: {
        padding: '32px 26px',
        height: '100%',
        width: '100%',
        textAlign: 'center',
        backgroundColor: theme.palette.grey[100],
        marginTop: 32
    },
    hireBannerButton: {
        fontSize: 12,
        width: 240,
        fontWeight: 700,
        margin: '0 6px',
        '&.later': {
            color: theme.palette.grey[900],
            backgroundColor: 'white'
        }
    },
    hireBannerHeader: {
        marginBottom: 25,
        fontWeight: 700,
        fontSize: 15
    }
}));
